import { useTranslation } from "react-i18next";
import {
  EViewerMode,
  ProjectDetailContext,
} from "../../../pages/ProjectDetail";
import { Q3DTabPanel } from "../../Parts/Q3DTabPanel";
import { MeasurementTypeButtons } from "./MeasurementTypeButtons";
import ReplyIcon from "@mui/icons-material/Reply";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import CalcContext from "../Contexts/CalcContext";
import { MeasurementType } from "../../../viewer/measurement/types";
import Q3DIconButton from "../../Parts/Q3DIconButton";
import { UpdateInfoContext } from "../Contexts/UpdateInfoContext";
import { UserSiteContext } from "../../../..";

type Props = {
  width?: string;
};

export const CalcTabPanel = (props: Props) => {
  const { currentViewerMode, projectDetail, viewer, detailTab } =
    useContext(ProjectDetailContext);
  const { onEditingMode, measurementType, setOnEditingMode } =
    useContext(CalcContext);
  const [clickCount, setClickCount] = useState<number>(0);
  const { t, i18n } = useTranslation();
  const { setUpdateAt, updateAt } = useContext(UpdateInfoContext);

  // onPointClickEvent
  const onPointClick = (e: any) => {
    const count = e?.detail?.count;
    setClickCount(count);
  };

  // useEffect(() => {
  //   document.addEventListener("onPointClick", onPointClick);
  //   return () => {
  //     document.removeEventListener("onPointClick", onPointClick);
  //   };
  // }, []);

  useEffect(() => {
    if (currentViewerMode !== EViewerMode.CALCULATION) return;

    document.addEventListener("onPointClick", onPointClick);

    return () => {
      setOnEditingMode(false);
      document.removeEventListener("onPointClick", onPointClick);
    };
  }, [currentViewerMode]);

  const releasePoints = () => {
    viewer.undoMeasurement();
  };

  const finishMeasurement = () => {
    if (onEditingMode) {
      setOnEditingMode(false);
      viewer.cancelEditingMeasurement();
      return;
    }
    for (let i = 0; i < clickCount; ++i) {
      viewer.undoMeasurement();
    }
  };

  const EndMeasurement = async () => {
    viewer.finishMeasurementCreation();
  };

  const StartMeasurement = () => {};

  const EndEditing = () => {
    setOnEditingMode(false);
    viewer.updateEditMeasurement(projectDetail.id, updateAt, setUpdateAt);
    viewer.finishMeasurement();
  };

  const IsDisablePointsButton = () => {
    return clickCount === 0;
  };

  const IsDisableCancelButton = () => {
    if (onEditingMode) return false;
    return clickCount === 0;
  };

  useEffect(() => {
    if (detailTab !== undefined) {
      setOnEditingMode(false);
    }
  }, [detailTab]);

  const IsDisableStartButton = () => {
    return (
      (clickCount < 3 &&
        (measurementType === MeasurementType.FLAT_AREA_CALCULATION ||
          measurementType === MeasurementType.VOLUME_CALCULATION) &&
        !onEditingMode) ||
      (clickCount < 2 &&
        measurementType === MeasurementType.MULTIPLE_POINT &&
        !onEditingMode) ||
      (measurementType !== MeasurementType.FLAT_AREA_CALCULATION &&
        measurementType !== MeasurementType.VOLUME_CALCULATION &&
        measurementType !== MeasurementType.MULTIPLE_POINT &&
        !onEditingMode)
    );
  };

  return (
    <Q3DTabPanel
      value={EViewerMode.CALCULATION}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "var(--space-space--4, 4px)",
        width: props.width,
        paddingLeft: "4px",
      }}
    >
      <MeasurementTypeButtons />
      <Q3DIconButton
        title={t("UNMARK")}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        icon={<ReplyIcon />}
        height={"36px"}
        onClick={releasePoints}
        disabled={IsDisablePointsButton()}
        type={"warning"}
        tooltipHidden={
          !(
            measurementType === MeasurementType.FLAT_AREA_CALCULATION ||
            measurementType === MeasurementType.VOLUME_CALCULATION ||
            measurementType === MeasurementType.MULTIPLE_POINT
          )
        }
        sx={{
          minWidth: "36px",
          visibility:
            !(
              measurementType === MeasurementType.FLAT_AREA_CALCULATION ||
              measurementType === MeasurementType.VOLUME_CALCULATION ||
              measurementType === MeasurementType.MULTIPLE_POINT
            ) && "hidden",
        }}
      />
      <Q3DIconButton
        title={t("CANCEL")}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        icon={<CloseIcon />}
        height={"36px"}
        onClick={finishMeasurement}
        disabled={IsDisableCancelButton()}
        type={"error"}
        sx={{ minWidth: "36px" }}
      />
      <Q3DIconButton
        title={t("CONFIRM")}
        titleType={i18n.language === "ja" ? "both" : "tooltip"}
        icon={<CheckIcon />}
        height={"36px"}
        onClick={
          onEditingMode
            ? EndEditing
            : measurementType === MeasurementType.FLAT_AREA_CALCULATION ||
              measurementType === MeasurementType.VOLUME_CALCULATION ||
              measurementType === MeasurementType.MULTIPLE_POINT
            ? EndMeasurement
            : StartMeasurement
        }
        disabled={IsDisableStartButton()}
        type={"default"}
        sx={{ minWidth: "36px" }}
      />
    </Q3DTabPanel>
  );
};
